import { styled, Typography } from '@material-ui/core';

export const NotFoundElement = styled(Typography)(({ theme }) => ({
    color: theme.palette.warning.main,
    textAlign: 'center',
}));
